import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorFactory } from './common/services/factories/custom-paginator-factory';
import { TranslateService } from '@ngx-translate/core';
import { ProjectionModule } from './container-components/projection/projection.module';
import { PipesModule, DirectivesModule } from './common';
import { FieldErrorMessagesModule } from './ui-kit/field-error-messages/field-error-messages.module';

const SHARED_MODULES = [
  CommonModule,
  MaterialModule,
  ReactiveFormsModule,
  ProjectionModule,
  PipesModule,
  DirectivesModule,
  FieldErrorMessagesModule,
];

@NgModule({
  imports: [...SHARED_MODULES, FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' })],
  providers: [
    {
      provide: MatPaginatorIntl,
      useFactory: CustomPaginatorFactory,
      deps: [TranslateService],
    },
  ],
  exports: [...SHARED_MODULES, FormsModule],
})
export class IntrackFeatureModule {}
